import { EraserIcon } from './icons/EraserIcon'

export function FilterEraser({ onClick, label }: { onClick: () => void; label: string }) {
  return (
    <button type="button" className="filter-eraser" title={label} aria-label={label} onClick={onClick}>
      <EraserIcon />
    </button>
  )
}
